import ApplicationController from "./application_controller"

export default class extends ApplicationController {
  static values = { url: String }

  connect() {
    window.location.href = this.urlValue;
  }
}
